/**************************************************
 * Nombre:       Tarjeta_Testimonio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Rating, Typography} from "@mui/material";
import ic_facebook from '../../Recursos/ic_facebook_color.png'
import ic_instagram from '../../Recursos/ic_instragram_color.png'
import {theme} from "../../Tema";

const Tarjeta_Testimonio = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >

            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <img src={item.img} width={'100%'} height={'auto'} style={{borderRadius: 20}}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={1}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', ml: -1}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={0}
                        >

                            {item.redes === 'Facebook' ?
                                <img src={ic_facebook} width={50} height={'auto'}/> :

                                item.redes === 'Instagram' ? <img src={ic_instagram} width={50} height={'auto'}/> :
                                    <>
                                        <img src={ic_facebook} width={50} height={'auto'}/>
                                        <img src={ic_instagram} width={50} height={'auto'}/>
                                    </>
                            }

                        </Grid>

                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{color: theme.palette.primary.main, fontSize: 20, fontWeight: 800}}
                        >{item.nombre}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Rating size={'Large'} value={5}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 14, fontWeight: 400}}>
                            {item.testimonio}
                        </Typography>
                    </Grid>

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Testimonio